import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { DataTable } from "../DataTable/DataTable";

export const SnnSchoolsPage: React.FC = () => {
  useDocumentTitle("SNN Schools");
  return (
    <main className="flex flex-col gap-6 p-6">
      <h1 className="text-2xl font-bold">SNN Schools</h1>
      <DataTableContextProvider
        source="/manager_new/schools/snn/list"
        filterable={["schoolid", "schoolName", "state", "zip"]}
        defaults={{ sortBy: [{ id: "schoolid", desc: false }] }}
        globalFilter
        fetchOnLoad
      >
        <DataTable />
      </DataTableContextProvider>
    </main>
  );
};
